import { Link, useNavigate } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { FiUser } from "react-icons/fi";
import { useAuth } from "../auth/AuthContext";
import "../css/navbar.css";

export default function MyNavbar({ onLoginClick }) {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const handleLogout = async () => {
    await logout(); // invalida sessione lato backend + pulisce FE
    navigate("/");
  };

  return (
    <Navbar expand="lg" sticky="top" variant="dark" className="my-navbar">
      <Container className="navbar-container">
        {/* Brand */}
        <div className="brand-zone">
          <Navbar.Brand as={Link} to="/" className="brand-flex">
            <img
              src="/LJ.png"
              alt="LJ logo"
              width="40"
              height="40"
              className="brand-logo"
            />
            <span>LYLE JOUBERT — Fitness &amp; Coaching</span>
          </Navbar.Brand>
          <span className="nav-divider" aria-hidden="true" />
        </div>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="align-items-center">
          {/* PAGES */}
          <Nav className="navbar-main-nav">
            <Nav.Link as={Link} to="/coaching">
              Coaching
            </Nav.Link>
            <Nav.Link as={Link} to="/workouts">
              Workouts
            </Nav.Link>
            <Nav.Link as={Link} to="/contatti">
              Contact
            </Nav.Link>
            <Nav.Link as={Link} to="/chisono">
              About
            </Nav.Link>
          </Nav>

          {/* RIGHT ACTIONS */}
          <div className="right-actions ms-auto">
            {/* Desktop: icona profilo con dropdown */}
            <div className="account-desktop d-none d-lg-flex">
              <Dropdown align="end">
                <Dropdown.Toggle
                  id="dropdown-account"
                  className="btn-account"
                  variant="link"
                  aria-label="Account menu"
                >
                  <FiUser className="user-icon" />
                  {isAuthenticated && (
                    <span className="user-chip">
                      @{user?.username ?? "user"}
                    </span>
                  )}
                </Dropdown.Toggle>

                {/* Menu con classi custom per colori + animazione */}
                <Dropdown.Menu className="account-menu dropdown-anim">
                  {isAuthenticated ? (
                    <>
                      <Dropdown.Header className="account-menu-header">
                        Signed in as{" "}
                        <strong>@{user?.username ?? "user"}</strong>
                      </Dropdown.Header>
                      <Dropdown.Divider className="account-divider" />
                      <Dropdown.Item as={Link} to="/profile">
                        Profile
                      </Dropdown.Item>

                      <Dropdown.Divider className="account-divider" />
                      <Dropdown.Item onClick={handleLogout} className="danger">
                        Logout
                      </Dropdown.Item>
                    </>
                  ) : (
                    <>
                      <Dropdown.Item onClick={onLoginClick}>
                        Log in
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/register"
                        className="primary"
                      >
                        Register
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {/* Mobile: azioni in chiaro dentro il collapse */}
            {!isAuthenticated ? (
              <div className="auth-group d-lg-none w-100">
                <Button
                  onClick={onLoginClick}
                  className="btn-auth btn-auth-login w-100 mb-2"
                >
                  Login
                </Button>
                <Button
                  as={Link}
                  to="/register"
                  className="btn-auth btn-auth-register w-100"
                >
                  Register
                </Button>
              </div>
            ) : (
              <div className="auth-group d-lg-none w-100">
                <Button
                  as={Link}
                  to="/profile"
                  className="btn-auth btn-auth-login w-100 mb-2"
                >
                  @{user?.username ?? "user"}
                </Button>
                <Button
                  onClick={handleLogout}
                  className="btn-auth btn-auth-register w-100"
                >
                  Logout
                </Button>
              </div>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
